import type { ISbStoryData } from '@storyblok/js';
import lodashOmit from 'lodash-es/omit';

import type { StoryMeta } from '#shared/types/storyblok.type';
import { INJECTION_KEYS } from '~/constants/injectionKeys';

export const useStoryblokProvideStoryMeta = (story: MaybeRefOrGetter<ISbStoryData | undefined>): void => {
    const storyMeta: ComputedRef<StoryMeta | undefined> = computed(() => {
        const s = toValue(story);

        return s ? lodashOmit(s, 'content') : undefined;
    });
    provide(INJECTION_KEYS.STORYBLOK_STORY_META, storyMeta);
};
